import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink } = FiIcons;

const ProfileCard = ({ profile, onTagClick }) => {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      whileTap={{ scale: 0.98 }}
      className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden h-full flex flex-col touch-manipulation"
    >
      <div className="p-5 flex-grow">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-start space-x-3 pr-4 overflow-hidden">
            {profile.profile_pic_url && (
              <img
                src={profile.profile_pic_url}
                alt={profile.name}
                className="w-16 h-16 rounded-full object-cover border border-slate-200 flex-shrink-0"
                onError={(e) => e.target.style.display = 'none'}
              />
            )}
            <div className="min-w-0">
              <h3 className="text-lg font-bold text-slate-900 leading-tight mb-1 truncate">{profile.name}</h3>
              <p className="text-sm font-medium text-slate-500 truncate">@{profile.instagram_handle}</p>
            </div>
          </div>
          <a
            href={`https://instagram.com/${profile.instagram_handle}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-slate-50 text-slate-400 hover:text-slate-700 active:bg-slate-100 transition-colors"
            aria-label="Visit Instagram Profile"
          >
            <SafeIcon icon={FiExternalLink} className="text-xl" />
          </a>
        </div>

        {profile.bio && (
          <p className="text-slate-600 mb-4 text-sm leading-relaxed line-clamp-3">
            {profile.bio}
          </p>
        )}
      </div>

      {(profile.tags && profile.tags.length > 0) && (
        <div className="px-5 pb-5 pt-0">
          <div className="flex flex-wrap gap-2">
            {profile.tags.slice(0, 3).map((tag, index) => (
              <button
                key={index}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent card click if needed
                  onTagClick(tag);
                }}
                className="px-3 py-1.5 text-xs font-semibold bg-slate-100 text-slate-700 rounded-lg active:bg-slate-200 transition-colors"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default ProfileCard;